import * as React from 'react';

import styles from './styles.module.scss';

export const Loader: React.FC = () => (
  <div className={styles.loader}>
    <span />
    <span />
    <span />
  </div>
);
